import * as React from "react";
import { DashboardIcon } from "@teamprevent/common/dashboard";

export class Users extends React.Component {
    public render() {
        return (
            <DashboardIcon href="/customerUsers" icon="/assets/users.svg" label="Users" />
        );
    }
}
